module.exports = __webpack_public_path__ + "img/mesa-de-frades.9ed03bdd.jpg";